import React from 'react'
import { Button, Flex, Icon, Modal, Text, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure } from '@chakra-ui/react';
import AddJob from './AddJob';
import { FiFilePlus } from 'react-icons/fi';

export const AddJobBtn = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <Button onClick={onOpen}
                mb="2"
                colorScheme="green"
                float="right"
                boxShadow="md"
                borderRadius="1.5em"
            >
                <Flex >
                    <Icon
                        as={FiFilePlus} mt="0.5" mr="1" />
                    <Text>Create a new job</Text>
                </Flex>


            </Button>

            <Modal size="xl" isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent mx="2">
                    <ModalHeader>Create a new job</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody >
                        <AddJob onClose={onClose} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
